import { getVoyageNumber } from "../../../utils/domainSelectors";
import { getSelectedCargo, getSelectedTrip } from "../../../utils/voyageSelection";

export const createRcsPrintViewModelV2 = ({
  currentVoyage,
  selectedTripId,
  selectedCargoIndex,
  inputRate,
  companyLogo,
  t,
}) => {
  const selectedTrip = getSelectedTrip(currentVoyage, selectedTripId);
  const selectedCargo = getSelectedCargo(
    currentVoyage,
    selectedTripId,
    selectedCargoIndex
  );

  if (!selectedCargo) {
    throw new Error(t("forPrint.selectCargoBeforePrint"));
  }

  return {
    companyLogo: companyLogo || "",
    vesselName: currentVoyage?.vessel || "\u2014",
    title: t("forPrint.rcsTitle"),
    toShippers: selectedTrip?.supplierReceiver || "\u2014",
    port: selectedTrip?.to || "\u2014",
    voyageNumber: getVoyageNumber(currentVoyage) || "\u2014",
    fromPort: selectedTrip?.from || "\u2014",
    toPort: selectedTrip?.to || "\u2014",
    cargoName: selectedCargo?.cargo || "\u2014",
    inputRate: inputRate ? `${inputRate} m3/h` : "\u2014",
    chiefOfficer: selectedTrip?.crew?.chiefOfficer || "\u2014",
    note: t("forPrint.capacityNote"),
    protestText: t("forPrint.protestText"),
    actualRateLabel: t("forPrint.actualRate"),
    commentsLabel: t("forPrint.comments"),
    loadingMasterLabel: t("forPrint.loadingMaster"),
  };
};
